const initialState = {};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case "AUTH_CHANGE":
      return {
        ...action.data,
      };

    default:
      return state;
  }
};

export default auth;
